import tableSportRoomContents from './tableSportRoomContents';

export default {
  title: 'Content Management',
  attributeName: 'appCategory',
  getURL: 'appId/areaId/appContent',
  createURL: '',
  updateURL: 'appId/areaId/appContentMultiple',
  removeURL: 'appId/areaId/appContent',
  sessionParams: ['appId', 'areaId'],
  removeNameField:'name',
  removeText:'You are about to remove the content with name ##name##.',
  tableConfig: tableSportRoomContents,
  autoUpdate: true,
  showOperatingSystem:true
};
